const scrollTop = document.getElementById('scroll__top');

// Click to scroll to top
scrollTop.addEventListener('click', function(){
  window.scroll({top: 0, left: 0, behavior: 'smooth'});
});

// Create dynamic style element for ::before updates
const style = document.createElement('style');
document.head.appendChild(style);

// Update on scroll
window.addEventListener('scroll', function(){
  // Calculate scroll progress
  const scrollPosition = window.scrollY;
  const docHeight = document.documentElement.scrollHeight - window.innerHeight;
  const scrollPercent = (scrollPosition / docHeight) * 100;

  // Update progress fill height
  style.textContent = `
    #scroll__top::before {
      height: ${scrollPercent}% !important;
    }
  `;

  // Show/hide button
  if(window.scrollY > 300){
    scrollTop.classList.add("active");
  }else{
    scrollTop.classList.remove("active");
  }

  // Change icon color when more than 50% filled
  if (scrollPercent > 50) {
    scrollTop.setAttribute('data-filled', 'true');
  } else {
    scrollTop.setAttribute('data-filled', 'false');
  }
}); 